var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("custom-btn-icon", {
    attrs: {
      "btn-text": _vm.generateMessage(
        "requests.actions.workorder_report_short"
      ),
      color: "success",
      icon: "mdi-file-outline"
    },
    on: {
      click: function($event) {
        $event.stopPropagation()
        return _vm.handleClick.apply(null, arguments)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }